import {
  CreditRequestBatchLineItemInput,
  CreditRequests_ValidateQuery,
  CreditRequests_ValidateQueryVariables,
} from '@/types';
import { gql } from '@apollo/client';
import { useCallback } from 'react';
import { useLazyQuery } from '@/hooks/use-lazy-query';

export const VALIDATE_CREDIT_REQUEST_QUERY = gql`
  query CreditRequests_Validate(
    $chatUUID: uuid!
    $creditRequestBatchLineItems: [CreditRequestBatchLineItemInput!]!
  ) {
    validateCreditRequest(
      chat_id: $chatUUID
      credit_request_batch_line_items: $creditRequestBatchLineItems
    ) {
      alerts {
        alert_level
        alert_message
        ineligible_variant_pack_ids
      }
    }
  }
`;

export const useValidateCreditRequest = () => {
  const validate = useLazyQuery<
    CreditRequests_ValidateQuery,
    CreditRequests_ValidateQueryVariables
  >(VALIDATE_CREDIT_REQUEST_QUERY, {
    fetchPolicy: 'network-only',
  });

  return useCallback(
    (
      chatUUID: string,
      creditRequestBatchLineItems: CreditRequestBatchLineItemInput[],
    ) => {
      return validate({
        variables: {
          chatUUID,
          creditRequestBatchLineItems,
        },
      });
    },
    [validate],
  );
};
